import Axios from "axios";
import {
    SET_BRANCH_LIST,
    UNSET_BRANCH_LIST,
    SET_CURRENT_BRANCH,
    UNSET_CURRENT_BRANCH
  } from "@/store/mutation-types";
import { saveUpdateBranchSetup, getBranchList, changeBranch } from "@/store/api";
// initial state
const state = {
  getBranchList: [],
  currentBranch: JSON.parse(localStorage.getItem("branch")),
};

const getters = {
  getBranchList(state) {
    return state.getBranchList;
  },
  getCurrentBranch(state) {
    let branch = JSON.parse(localStorage.getItem("branch"));
    state.currentBranch = branch;
    return state.currentBranch ? state.currentBranch : branch;
  },
};
const mutations = {
  [SET_BRANCH_LIST](state, data) {
    state.getBranchList = data;
  },
  [UNSET_BRANCH_LIST](state) {
    state.getBranchList = [];
  },
  [SET_CURRENT_BRANCH](state, branch) {
    state.currentBranch = branch;
  },
  [UNSET_CURRENT_BRANCH](state) {
    state.currentBranch = "";
  }

};

const actions = {

  saveUpdateBranchSetup({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateBranchSetup, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getBranchList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getBranchList, data)
        .then(function (response) {
          commit('SET_BRANCH_LIST',response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_BRANCH_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  changeBranch({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(changeBranch, data)
        .then(function (response) {
          commit('SET_AUTH_USER',response.data.user);
          commit('SET_CURRENT_BRANCH',response.data.branch);

          commit("SET_CURRENT_COMPANY", response.data.branch.company);
          commit("SET_USER_PERMISSION", response.data.menu);

          localStorage.setItem("user", JSON.stringify(response.data.user));
          localStorage.setItem("branch", JSON.stringify(response.data.branch));
          localStorage.setItem("menu", JSON.stringify(response.data.menu));
          localStorage.setItem("company", JSON.stringify(response.data.branch.company));

          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },


};

export default {
  state,
  getters,
  actions,
  mutations,
};
